import React from 'react';
import CallRecorder, { CallData } from './CallRecorder';
import './CallRecorderModal.css';

interface CallRecorderModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (callData: CallData) => void;
  initialFrom?: string;
  initialTo?: string;
  clientPhoneNumber?: string;
  userFirstname?: string;
  userLastname?: string;
  claimId?: string;
}

export default function CallRecorderModal({
  isOpen,
  onClose,
  onSave,
  initialFrom,
  initialTo,
  clientPhoneNumber,
  userFirstname,
  userLastname,
  claimId
}: CallRecorderModalProps) {
  if (!isOpen) return null;

  const handleSave = (callData: CallData) => {
    onSave(callData);
    onClose();
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content call-recorder-modal" onClick={(e) => e.stopPropagation()}>
        <CallRecorder
          onSave={handleSave}
          onCancel={onClose}
          initialFrom={initialFrom}
          initialTo={initialTo}
          clientPhoneNumber={clientPhoneNumber}
          userFirstname={userFirstname}
          userLastname={userLastname}
          claimId={claimId}
        />
      </div>
    </div>
  );
}